/**
 * External dependencies
 */
import { values } from 'lodash';

/**
 * Internal dependencies
 */
import getRawReports from'./get-raw-reports';

export default (state) => values(getRawReports(state));